import { useTranslation } from '@thoughtspot/i18n';
import { useCallback, useEffect, useRef, useState } from 'react';
import { VariableResponseContent } from "../../../../services/generated/graphql-types";
import { TranslationsKeys } from '../../variable-interface';
export const useVariableNameCheck = (useSearchVariablesLazyQuery) => {
    const { t } = useTranslation();
    const [nameError, setNameError] = useState(null);
    const pendingNameCheckRef = useRef(null);
    const { searchVariables, data: searchVariablesData, loading: searchVariablesLoading, } = useSearchVariablesLazyQuery();
    useEffect(() => {
        if (!searchVariablesLoading && pendingNameCheckRef.current) {
            const { name, resolve } = pendingNameCheckRef.current;
            const variables = searchVariablesData?.data;
            if (variables && variables.length > 0) {
                const exactMatch = variables.find(variable => variable?.name?.toLowerCase() === name.toLowerCase());
                if (exactMatch) {
                    setNameError(t(TranslationsKeys.ERROR_NAME_EXISTS));
                    resolve(true);
                }
                else {
                    setNameError(null);
                    resolve(false);
                }
            }
            else {
                setNameError(null);
                resolve(false);
            }
            pendingNameCheckRef.current = null;
        }
    }, [searchVariablesData, searchVariablesLoading, t]);
    const checkVariableNameExists = useCallback((name) => {
        return new Promise(resolve => {
            pendingNameCheckRef.current = { name, resolve };
            searchVariables({
                variable_details: {
                    name_pattern: name,
                },
                record_offset: 0,
                record_size: 1,
                response_content: VariableResponseContent.MetadataAndValues,
            });
        });
    }, [searchVariables]);
    const clearNameError = useCallback(() => {
        setNameError(null);
    }, []);
    return {
        checkVariableNameExists,
        isCheckingVariableName: searchVariablesLoading,
        nameError,
        clearNameError,
    };
};
//# sourceMappingURL=useVariableNameCheck.js.map